import {COUNTRIES_WITH_VAT} from '../../components/Checkout/constants';
import {CartModel} from '../models/checkout/Cart/Cart.model';
import {vatIdTypeMapV1, VatType} from '../models/checkout/Cart/VatId.model';
import {WixCommonVatType} from '../../gql/graphql';
import {flipMap} from './mapperHelper.utils';

export const getVatType = (type?: string): VatType => {
  switch (type) {
    /* istanbul ignore next */ case 'CPF':
      return /* istanbul ignore next */ VatType.CPF;
    case 'CNPJ':
      return /* istanbul ignore next */ VatType.CNPJ;
    /* istanbul ignore next */ default:
      return /* istanbul ignore next */ VatType.UNSPECIFIED;
  }
};

export const vatTypeToGQLVatType: Record<VatType, WixCommonVatType> = flipMap(vatIdTypeMapV1);

export const isCountryWithVAT = (cart: CartModel) => {
  const billingCountry = cart.paymentInfo.address?.country ?? '';
  const shippingCountry = cart.deliveryInfo?.address?.country ?? '';

  return COUNTRIES_WITH_VAT.includes(billingCountry) || COUNTRIES_WITH_VAT.includes(shippingCountry);
};
